import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ProjectService } from '../Services/project.service';
import { Chart } from 'chart.js';
import { ChartToolTipServiceService } from '../Services/chart-tool-tip-service.service';
import { JsonPipe } from '@angular/common';
import { SanitizationService } from '../Services/sanitization.service';

// import 'chartjs-plugin-zoom'; // Import the zoom plugin

@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.css'],
    standalone: false
})
export class DonutChartComponent {
  @ViewChild("myChart", { static: true })
  myChart: ElementRef<HTMLCanvasElement>;
  chart: Chart;
  @Input("data") data;
  @Input("labels") labels;
  @Input("chartdata") chartdata: any = [];
  _chart: Chart;
  isdata = true;
  tooltipData;
  isData = true;
  constructor(private renderer: Renderer2, private _projectService: ProjectService, private _chartService: ChartToolTipServiceService, private sanitization: SanitizationService) {
    this._projectService.donutChart.subscribe((value) => {
      this.chartdata = value.data;
      this.tooltipData = value.data;
      this.updateChart();
    });
    this._projectService.chardData.subscribe((value) => {
      this.data = JSON.parse(value.data);
      if (this.data.length == 0) {
        this.isData = false;
      } else {
        this.isData = true;
      }
    });
    this._projectService.ChartLabel.subscribe((value) => {
      this.labels = JSON.parse(value.data);
      this.updateChart();
    });
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.createPieChart();
  }

  createPieChart() {
    const canvas = this.renderer.createElement("canvas");
    this.renderer.appendChild(
      document.getElementById("donutChartContainer"),
      canvas
    );
    const ctx = canvas.getContext("2d");
    this.chart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Idle Working", "Productive", "Total Working"],
        datasets: [
          {
            data: [20, 80],
            backgroundColor: [
              "rgba(117, 117, 117, 0.6)",
              "rgba(126, 87, 194, 0.6)",
              "rgb(0, 151, 167, 0.6)",
            ],
            borderWidth: 1,
          },
          {
            data: [0, 0, 100],
            backgroundColor: [
              "rgba(117, 117, 117, 0.6)",
              "rgba(126, 87, 194, 0.6)",
              "rgb(0, 151, 167, 0.6)",
            ],
            borderWidth: 0,
          },
        ],
      },

      options: {
        cutout: '85%',
        responsive: true,
        animation: {
          animateRotate: true,
          animateScale: false,
          duration: 1000
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: false,
            external: (context: any) => {
              const { chart, tooltip: tooltipModel } = context;

              var tooltipEl: any = document.getElementById('chartjs-tooltip');

              const tableStyle = `
      background-color: rgba(33, 33, 33, 0.8);
      color: #ffffff; 
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 14px;
    `;

              const contentStyle = `
      font-size: 14px !important;
      margin: 3px;
    `;

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip';
                const sanitizedTable = this.sanitization.sanitizeHtml(`<table style="${tableStyle}"></table>`);
                tooltipEl.innerHTML = sanitizedTable as string;
                document.body.appendChild(tooltipEl);
              }

              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              if (tooltipModel.body) {
                var titleLines = tooltipModel.title || [];
                var bodyLines = tooltipModel.body.map((bodyItem) => bodyItem.lines);

                var innerHtml = '<thead><tr>';
                let dataindex: number | undefined;
                if (tooltipModel.dataPoints) {
                  dataindex = tooltipModel.dataPoints[0].dataIndex;
                }
                let displayData: string;
                let tool = this.chartdata;

                if (tool) {
                  if (dataindex == 0) {
                    displayData = tool.idle_time;
                  } else if (dataindex == 1) {
                    displayData = tool.productive_time;
                  } else {
                    displayData = tool.usage_time;
                  }
                }

                titleLines.forEach(function (title: any) {
                  if (title.includes(",")) {
                    let splitedTitle = title.split(",");
                    innerHtml += `
            <th>
              <span style="${contentStyle}">${splitedTitle[0]}</span>
            </th>
            <th>
              <span style="${contentStyle}">${displayData}</span>
            </th>`;
                  } else {
                    innerHtml += `
            <th>
              <span style="${contentStyle}">${title}</span>
            </th>`;
                  }
                });

                innerHtml += '</tr></thead><tbody>';

                bodyLines.forEach(function (body) {
                  let splitedData = body[0].split(":");
                  if (splitedData[0] != "No used application" && splitedData[0] != "undefined") {
                    innerHtml += `
                  <tr style="margin: 0px 10px !important;">
                    <td><span style="${contentStyle}">${splitedData[0]}</span></td>
                    <td><span style="${contentStyle}">${displayData.split(":")[0] != '0' ? displayData.split(":")[0] + "h" : ""} ${displayData.split(":")[1] != '0' ? displayData.split(":")[1] + "m" : ""}</span></td>
                  </tr>`;
                  } else {
                    innerHtml += `
                <tr style="margin: 0px 10px !important;">
                <td><span style="${contentStyle}">No used application</span></td>
               </tr>`;
                  }
                });

                innerHtml += '</tbody>';
                var tableRoot = tooltipEl.querySelector('table');
                const sanitizedInnerHtml = this.sanitization.sanitizeHtml(innerHtml);
                tableRoot.innerHTML = sanitizedInnerHtml as string;
              }

              var position = chart.canvas.getBoundingClientRect();
              tooltipEl.style.opacity = 1;
              tooltipEl.style.position = 'absolute';
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
              tooltipEl.style.padding = '5px 10px';
              tooltipEl.style.pointerEvents = 'none';
            },
          },
        },
      },
      plugins: [{
        id: 'centerText',
        afterDraw: (chart: any) => {
          const width = chart.width;
          const height = chart.height;
          const ctx = chart.ctx;

          ctx.restore();
          const fontSize = (height / 150).toFixed(2);
          ctx.font = fontSize + "em sans-serif";
          ctx.textBaseline = "middle";
          ctx.fillStyle = "#000000";

          const text = "Avg: " + 7.5;
          const textX = Math.round((width - ctx.measureText(text).width) / 2);
          const textY = height / 2;

          ctx.fillText(text, textX, textY);
          ctx.save();
        }
      }]
    } as any);
  }

  updateChart() {
    if (this.chartdata) {
      this.isdata = true;
      this.chart.data.labels = ["Idle Working", "Productive", "Total Working"];
      this.chart.data.datasets[0].data = [this.convertToMilliseconds(this.chartdata.idle_time), this.convertToMilliseconds(this.chartdata.productive_time), 0];
      this.chart.data.datasets[1].data = [0, 0, this.convertToMilliseconds(this.chartdata.usage_time)]
    } else {
      this.isdata = false;
      this.chart.data.labels = ["No used application"];
      this.chart.data.datasets[0].data = [100];
    }
    this.chart.update();
  }

  convertToMilliseconds(timeString) {
    const timeParts = timeString.split(':');
    const hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);
    const seconds = parseInt(timeParts[2]);

    // Calculate milliseconds
    return (hours * 3600 + minutes * 60 + seconds) * 1000;
  }

  convertMillisecondsToTime(ms: number): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');

    return `${hoursStr}:${minutesStr}:${secondsStr}`;
  }
}
